import { a as __rest, b as __read, _ as __assign } from './chunks/tslib.es6-abedb58f.js';
import React__default, { useRef, useState, useCallback, useEffect } from 'react';
import { useStyles, useBoolean } from '@sravni/react-utils';

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var queue$1 = {};

var interopRequireDefault = {exports: {}};

(function (module) {
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(interopRequireDefault));

var _extends = {exports: {}};

(function (module) {
function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(_extends));

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var Op = Object.prototype;
var hasOwn = Op.hasOwnProperty;
var undefined$1; // More compressible than void 0.
var $Symbol = typeof Symbol === "function" ? Symbol : {};
var iteratorSymbol = $Symbol.iterator || "@@iterator";
var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

function wrap(innerFn, outerFn, self, tryLocsList) {
  // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
  var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
  var generator = Object.create(protoGenerator.prototype);
  var context = new Context(tryLocsList || []);

  // The ._invoke method unifies the implementations of the .next,
  // .throw, and .return methods.
  generator._invoke = makeInvokeMethod(innerFn, self, context);

  return generator;
}

// Try/catch helper to minimize deoptimizations. Returns a completion
// record like context.tryEntries[i].completion. This interface could
// have been (and was previously) designed to take a closure to be
// invoked without arguments, but in all the cases we care about we
// already have an existing method we want to call, so there's no need
// to create a new function object. We can even get away with assuming
// the method takes exactly one argument, since that happens to be true
// in every case, so we don't have to touch the arguments object. The
// only additional allocation required is the completion record, which
// has a stable shape and so hopefully should be cheap to allocate.
function tryCatch(fn, obj, arg) {
  try {
    return { type: "normal", arg: fn.call(obj, arg) };
  } catch (err) {
    return { type: "throw", arg: err };
  }
}

var GenStateSuspendedStart = "suspendedStart";
var GenStateSuspendedYield = "suspendedYield";
var GenStateExecuting = "executing";
var GenStateCompleted = "completed";

// Returning this object from the innerFn has the same effect as
// breaking out of the dispatch switch statement.
var ContinueSentinel = {};

// Dummy constructor functions that we use as the .constructor and
// .constructor.prototype properties for functions that return Generator
// objects. For full spec compliance, you may wish to configure your
// minifier not to mangle the names of these two functions.
function Generator() {}
function GeneratorFunction() {}
function GeneratorFunctionPrototype() {}

// This is a polyfill for %IteratorPrototype% for environments that
// don't natively support it.
var IteratorPrototype = {};
IteratorPrototype[iteratorSymbol] = function () {
  return this;
};

var getProto = Object.getPrototypeOf;
var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
if (NativeIteratorPrototype &&
  NativeIteratorPrototype !== Op &&
  hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
  // This environment has a native %IteratorPrototype%; use it instead
  // of the polyfill.
  IteratorPrototype = NativeIteratorPrototype;
}

var Gp = GeneratorFunctionPrototype.prototype =
  Generator.prototype = Object.create(IteratorPrototype);
GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
GeneratorFunctionPrototype.constructor = GeneratorFunction;
GeneratorFunctionPrototype[toStringTagSymbol] =
  GeneratorFunction.displayName = "GeneratorFunction";

// Helper for defining the .next, .throw, and .return methods of the
// Iterator interface in terms of a single ._invoke method.
function defineIteratorMethods(prototype) {
  ["next", "throw", "return"].forEach(function(method) {
    prototype[method] = function(arg) {
      return this._invoke(method, arg);
    };
  });
}

function isGeneratorFunction (genFun) {
  var ctor = typeof genFun === "function" && genFun.constructor;
  return ctor
    ? ctor === GeneratorFunction ||
    // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction"
    : false;
}
function mark (genFun) {
  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
  } else {
    genFun.__proto__ = GeneratorFunctionPrototype;
    if (!(toStringTagSymbol in genFun)) {
      genFun[toStringTagSymbol] = "GeneratorFunction";
    }
  }
  genFun.prototype = Object.create(Gp);
  return genFun;
}
// Within the body of any async function, `await x` is transformed to
// `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
// `hasOwn.call(value, "__await")` to determine if the yielded value is
// meant to be awaited.
function awrap (arg) {
  return { __await: arg };
}
function AsyncIterator(generator, PromiseImpl) {
  function invoke(method, arg, resolve, reject) {
    var record = tryCatch(generator[method], generator, arg);
    if (record.type === "throw") {
      reject(record.arg);
    } else {
      var result = record.arg;
      var value = result.value;
      if (value &&
        typeof value === "object" &&
        hasOwn.call(value, "__await")) {
        return PromiseImpl.resolve(value.__await).then(function(value) {
          invoke("next", value, resolve, reject);
        }, function(err) {
          invoke("throw", err, resolve, reject);
        });
      }

      return PromiseImpl.resolve(value).then(function(unwrapped) {
        // When a yielded Promise is resolved, its final value becomes
        // the .value of the Promise<{value,done}> result for the
        // current iteration.
        result.value = unwrapped;
        resolve(result);
      }, function(error) {
        // If a rejected Promise was yielded, throw the rejection back
        // into the async generator function so it can be handled there.
        return invoke("throw", error, resolve, reject);
      });
    }
  }

  var previousPromise;

  function enqueue(method, arg) {
    function callInvokeWithMethodAndArg() {
      return new PromiseImpl(function(resolve, reject) {
        invoke(method, arg, resolve, reject);
      });
    }

    return previousPromise =
      // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(
        callInvokeWithMethodAndArg,
        // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg
      ) : callInvokeWithMethodAndArg();
  }

  // Define the unified helper method that is used to implement .next,
  // .throw, and .return (see defineIteratorMethods).
  this._invoke = enqueue;
}

defineIteratorMethods(AsyncIterator.prototype);
AsyncIterator.prototype[asyncIteratorSymbol] = function () {
  return this;
};

// Note that simple async functions are implemented on top of
// AsyncIterator objects; they just return a Promise for the value of
// the final result produced by the iterator.
 function async (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
  if (PromiseImpl === void 0) PromiseImpl = Promise;

  var iter = new AsyncIterator(
    wrap(innerFn, outerFn, self, tryLocsList),
    PromiseImpl
  );

  return isGeneratorFunction(outerFn)
    ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function(result) {
      return result.done ? result.value : iter.next();
    });
}
function makeInvokeMethod(innerFn, self, context) {
  var state = GenStateSuspendedStart;

  return function invoke(method, arg) {
    if (state === GenStateExecuting) {
      throw new Error("Generator is already running");
    }

    if (state === GenStateCompleted) {
      if (method === "throw") {
        throw arg;
      }

      // Be forgiving, per 25.3.3.3.3 of the spec:
      // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
      return doneResult();
    }

    context.method = method;
    context.arg = arg;

    while (true) {
      var delegate = context.delegate;
      if (delegate) {
        var delegateResult = maybeInvokeDelegate(delegate, context);
        if (delegateResult) {
          if (delegateResult === ContinueSentinel) continue;
          return delegateResult;
        }
      }

      if (context.method === "next") {
        // Setting context._sent for legacy support of Babel's
        // function.sent implementation.
        context.sent = context._sent = context.arg;

      } else if (context.method === "throw") {
        if (state === GenStateSuspendedStart) {
          state = GenStateCompleted;
          throw context.arg;
        }

        context.dispatchException(context.arg);

      } else if (context.method === "return") {
        context.abrupt("return", context.arg);
      }

      state = GenStateExecuting;

      var record = tryCatch(innerFn, self, context);
      if (record.type === "normal") {
        // If an exception is thrown from innerFn, we leave state ===
        // GenStateExecuting and loop back for another invocation.
        state = context.done
          ? GenStateCompleted
          : GenStateSuspendedYield;

        if (record.arg === ContinueSentinel) {
          continue;
        }

        return {
          value: record.arg,
          done: context.done
        };

      } else if (record.type === "throw") {
        state = GenStateCompleted;
        // Dispatch the exception by looping back around to the
        // context.dispatchException(context.arg) call above.
        context.method = "throw";
        context.arg = record.arg;
      }
    }
  };
}

// Call delegate.iterator[context.method](context.arg) and handle the
// result, either by returning a { value, done } result from the
// delegate iterator, or by modifying context.method and context.arg,
// setting context.delegate to null, and returning the ContinueSentinel.
function maybeInvokeDelegate(delegate, context) {
  var method = delegate.iterator[context.method];
  if (method === undefined$1) {
    // A .throw or .return when the delegate iterator has no .throw
    // method always terminates the yield* loop.
    context.delegate = null;

    if (context.method === "throw") {
      // Note: ["return"] must be used for ES3 parsing compatibility.
      if (delegate.iterator["return"]) {
        // If the delegate iterator has a return method, give it a
        // chance to clean up.
        context.method = "return";
        context.arg = undefined$1;
        maybeInvokeDelegate(delegate, context);

        if (context.method === "throw") {
          // If maybeInvokeDelegate(context) changed context.method from
          // "return" to "throw", let that override the TypeError below.
          return ContinueSentinel;
        }
      }

      context.method = "throw";
      context.arg = new TypeError(
        "The iterator does not provide a 'throw' method");
    }

    return ContinueSentinel;
  }

  var record = tryCatch(method, delegate.iterator, context.arg);

  if (record.type === "throw") {
    context.method = "throw";
    context.arg = record.arg;
    context.delegate = null;
    return ContinueSentinel;
  }

  var info = record.arg;

  if (! info) {
    context.method = "throw";
    context.arg = new TypeError("iterator result is not an object");
    context.delegate = null;
    return ContinueSentinel;
  }

  if (info.done) {
    // Assign the result of the finished delegate to the temporary
    // variable specified by delegate.resultName (see delegateYield).
    context[delegate.resultName] = info.value;

    // Resume execution at the desired location (see delegateYield).
    context.next = delegate.nextLoc;

    // If context.method was "throw" but the delegate handled the
    // exception, let the outer generator proceed normally. If
    // context.method was "next", forget context.arg since it has been
    // "consumed" by the delegate iterator. If context.method was
    // "return", allow the original .return call to continue in the
    // outer generator.
    if (context.method !== "return") {
      context.method = "next";
      context.arg = undefined$1;
    }

  } else {
    // Re-yield the result returned by the delegate method.
    return info;
  }

  // The delegate iterator is finished, so forget it and continue with
  // the outer generator.
  context.delegate = null;
  return ContinueSentinel;
}

// Define Generator.prototype.{next,throw,return} in terms of the
// unified ._invoke helper method.
defineIteratorMethods(Gp);

Gp[toStringTagSymbol] = "Generator";

// A Generator should always return itself as the iterator object when the
// @@iterator function is called on it. Some browsers' implementations of the
// iterator prototype chain incorrectly implement this, causing the Generator
// object to not be returned from this call. This ensures that doesn't happen.
// See https://github.com/facebook/regenerator/issues/274 for more details.
Gp[iteratorSymbol] = function() {
  return this;
};

Gp.toString = function() {
  return "[object Generator]";
};

function pushTryEntry(locs) {
  var entry = { tryLoc: locs[0] };

  if (1 in locs) {
    entry.catchLoc = locs[1];
  }

  if (2 in locs) {
    entry.finallyLoc = locs[2];
    entry.afterLoc = locs[3];
  }

  this.tryEntries.push(entry);
}

function resetTryEntry(entry) {
  var record = entry.completion || {};
  record.type = "normal";
  delete record.arg;
  entry.completion = record;
}

function Context(tryLocsList) {
  // The root entry object (effectively a try statement without a catch
  // or a finally block) gives us a place to store values thrown from
  // locations where there is no enclosing try statement.
  this.tryEntries = [{ tryLoc: "root" }];
  tryLocsList.forEach(pushTryEntry, this);
  this.reset(true);
}

function keys (object) {
  var keys = [];
  for (var key in object) {
    keys.push(key);
  }
  keys.reverse();

  // Rather than returning an object with a next method, we keep
  // things simple and return the next function itself.
  return function next() {
    while (keys.length) {
      var key = keys.pop();
      if (key in object) {
        next.value = key;
        next.done = false;
        return next;
      }
    }

    // To avoid creating an additional object, we just hang the .value
    // and .done properties off the next function object itself. This
    // also ensures that the minifier will not anonymize the function.
    next.done = true;
    return next;
  };
}
function values(iterable) {
  if (iterable) {
    var iteratorMethod = iterable[iteratorSymbol];
    if (iteratorMethod) {
      return iteratorMethod.call(iterable);
    }

    if (typeof iterable.next === "function") {
      return iterable;
    }

    if (!isNaN(iterable.length)) {
      var i = -1, next = function next() {
        while (++i < iterable.length) {
          if (hasOwn.call(iterable, i)) {
            next.value = iterable[i];
            next.done = false;
            return next;
          }
        }

        next.value = undefined$1;
        next.done = true;

        return next;
      };

      return next.next = next;
    }
  }

  // Return an iterator with no values.
  return { next: doneResult };
}

function doneResult() {
  return { value: undefined$1, done: true };
}

Context.prototype = {
  constructor: Context,

  reset: function(skipTempReset) {
    this.prev = 0;
    this.next = 0;
    // Resetting context._sent for legacy support of Babel's
    // function.sent implementation.
    this.sent = this._sent = undefined$1;
    this.done = false;
    this.delegate = null;

    this.method = "next";
    this.arg = undefined$1;

    this.tryEntries.forEach(resetTryEntry);

    if (!skipTempReset) {
      for (var name in this) {
        // Not sure about the optimal order of these conditions:
        if (name.charAt(0) === "t" &&
          hasOwn.call(this, name) &&
          !isNaN(+name.slice(1))) {
          this[name] = undefined$1;
        }
      }
    }
  },

  stop: function() {
    this.done = true;

    var rootEntry = this.tryEntries[0];
    var rootRecord = rootEntry.completion;
    if (rootRecord.type === "throw") {
      throw rootRecord.arg;
    }

    return this.rval;
  },

  dispatchException: function(exception) {
    if (this.done) {
      throw exception;
    }

    var context = this;
    function handle(loc, caught) {
      record.type = "throw";
      record.arg = exception;
      context.next = loc;

      if (caught) {
        // If the dispatched exception was caught by a catch block,
        // then let that catch block handle the exception normally.
        context.method = "next";
        context.arg = undefined$1;
      }

      return !! caught;
    }

    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
      var entry = this.tryEntries[i];
      var record = entry.completion;

      if (entry.tryLoc === "root") {
        // Exception thrown outside of any try block that could handle
        // it, so set the completion value of the entire function to
        // throw the exception.
        return handle("end");
      }

      if (entry.tryLoc <= this.prev) {
        var hasCatch = hasOwn.call(entry, "catchLoc");
        var hasFinally = hasOwn.call(entry, "finallyLoc");

        if (hasCatch && hasFinally) {
          if (this.prev < entry.catchLoc) {
            return handle(entry.catchLoc, true);
          } else if (this.prev < entry.finallyLoc) {
            return handle(entry.finallyLoc);
          }

        } else if (hasCatch) {
          if (this.prev < entry.catchLoc) {
            return handle(entry.catchLoc, true);
          }

        } else if (hasFinally) {
          if (this.prev < entry.finallyLoc) {
            return handle(entry.finallyLoc);
          }

        } else {
          throw new Error("try statement without catch or finally");
        }
      }
    }
  },

  abrupt: function(type, arg) {
    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
      var entry = this.tryEntries[i];
      if (entry.tryLoc <= this.prev &&
        hasOwn.call(entry, "finallyLoc") &&
        this.prev < entry.finallyLoc) {
        var finallyEntry = entry;
        break;
      }
    }

    if (finallyEntry &&
      (type === "break" ||
        type === "continue") &&
      finallyEntry.tryLoc <= arg &&
      arg <= finallyEntry.finallyLoc) {
      // Ignore the finally entry if control is not jumping to a
      // location outside the try/catch block.
      finallyEntry = null;
    }

    var record = finallyEntry ? finallyEntry.completion : {};
    record.type = type;
    record.arg = arg;

    if (finallyEntry) {
      this.method = "next";
      this.next = finallyEntry.finallyLoc;
      return ContinueSentinel;
    }

    return this.complete(record);
  },

  complete: function(record, afterLoc) {
    if (record.type === "throw") {
      throw record.arg;
    }

    if (record.type === "break" ||
      record.type === "continue") {
      this.next = record.arg;
    } else if (record.type === "return") {
      this.rval = this.arg = record.arg;
      this.method = "return";
      this.next = "end";
    } else if (record.type === "normal" && afterLoc) {
      this.next = afterLoc;
    }

    return ContinueSentinel;
  },

  finish: function(finallyLoc) {
    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
      var entry = this.tryEntries[i];
      if (entry.finallyLoc === finallyLoc) {
        this.complete(entry.completion, entry.afterLoc);
        resetTryEntry(entry);
        return ContinueSentinel;
      }
    }
  },

  "catch": function(tryLoc) {
    for (var i = this.tryEntries.length - 1; i >= 0; --i) {
      var entry = this.tryEntries[i];
      if (entry.tryLoc === tryLoc) {
        var record = entry.completion;
        if (record.type === "throw") {
          var thrown = record.arg;
          resetTryEntry(entry);
        }
        return thrown;
      }
    }

    // The context.catch method must only be called with a location
    // argument that corresponds to a known catch block.
    throw new Error("illegal catch attempt");
  },

  delegateYield: function(iterable, resultName, nextLoc) {
    this.delegate = {
      iterator: values(iterable),
      resultName: resultName,
      nextLoc: nextLoc
    };

    if (this.method === "next") {
      // Deliberately forget the last sent value so that we don't
      // accidentally pass it on to the delegate.
      this.arg = undefined$1;
    }

    return ContinueSentinel;
  }
};

// Export a default namespace that plays well with Rollup
var index = {
  wrap,
  isGeneratorFunction,
  AsyncIterator,
  mark,
  awrap,
  async,
  keys,
  values
};

var regenerator = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': index
});

var require$$2 = /*@__PURE__*/getAugmentedNamespace(regenerator);

var asyncToGenerator = {exports: {}};

(function (module) {
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(asyncToGenerator));

var logger = {};

Object.defineProperty(logger, "__esModule", {
  value: true
});
logger.default = void 0;
var LEVELS = {
  DEBUG: 'debug',
  INFO: 'info',
  WARNING: 'warn',
  ERROR: 'error'
};
var LEVEL_LABELS = {
  [LEVELS.DEBUG]: 'debug',
  [LEVELS.INFO]: 'info',
  [LEVELS.WARNING]: 'warn',
  [LEVELS.ERROR]: 'error'
};
var LEVEL_COLORS = {
  [LEVELS.DEBUG]: '#00CCFF',
  [LEVELS.INFO]: '#6600CC',
  [LEVELS.WARNING]: '#FF9933',
  [LEVELS.ERROR]: '#CC3333'
};
var DEFAULT_CONTEXT = 'app';
/**
 * Fast and simple dev logger
 * @description Logs visible only in development environment
 * @class
 * @example
 * ```ts
 * const logger = new Logger('test')
 * logger.debug('Test message', { a: 'b', b: 'a' })
 * ```
 */

var Logger = /*#__PURE__*/function () {
  /**
   * @param context Logger context
   */
  function Logger(context) {
    if (context === void 0) {
      context = DEFAULT_CONTEXT;
    }

    this.context = context;
  }
  /**
   * Print log message to console
   * @param level Log level
   * @param message Text message
   * @param [meta] Additional data
   */


  var _proto = Logger.prototype;

  _proto.log = function log(level, message, meta) {
    if (process.env.NODE_ENV === 'development') {
      var label = this.context;
      var color = LEVEL_COLORS[level];
      var labelStyle = "font-weight: bold; color: " + color;
      var ctxStyle = 'font-weight: bold; color: #CC00FF';
      var msgStyle = 'font-weight: normal;';
      var time = new Date().toLocaleTimeString();

      if (typeof message === 'object') {
        console.log("%c" + time + " %c[" + LEVEL_LABELS[level] + "] %c" + label + " ", msgStyle, labelStyle, ctxStyle, message);
      } else {
        if (typeof meta !== 'undefined') {
          console.groupCollapsed("%c" + time + " %c[" + LEVEL_LABELS[level] + "] %c" + label + " %c" + message, msgStyle, labelStyle, ctxStyle, msgStyle);
          console.log(meta);
          console.groupEnd();
        } else {
          console.log("%c" + time + " %c[" + LEVEL_LABELS[level] + "] %c" + label + " %c" + message, msgStyle, labelStyle, ctxStyle, msgStyle);
        }
      }
    }
  }
  /**
   * Print log with debug level
   * @param message Text message
   * @param meta Additional data
   */
  ;

  _proto.debug = function debug(message, meta) {
    this.log(LEVELS.DEBUG, message, meta);
  }
  /**
   * Print log with info level
   * @param message Text message
   * @param meta Additional data
   */
  ;

  _proto.info = function info(message, meta) {
    this.log(LEVELS.INFO, message, meta);
  }
  /**
   * Print log with warning level
   * @param message Text message
   * @param meta Additional data
   */
  ;

  _proto.warn = function warn(message, meta) {
    this.log(LEVELS.WARNING, message, meta);
  }
  /**
   * Print log with error level
   * @param message Text message
   * @param meta Additional data
   */
  ;

  _proto.error = function error(message, meta) {
    this.log(LEVELS.ERROR, message, meta);
  };

  return Logger;
}();

var _default$1 = Logger;
logger.default = _default$1;

var _interopRequireDefault = interopRequireDefault.exports;

Object.defineProperty(queue$1, "__esModule", {
  value: true
});
var default_1 = queue$1.default = void 0;

var _extends2 = _interopRequireDefault(_extends.exports);

var _regenerator = _interopRequireDefault(require$$2);

var _asyncToGenerator2 = _interopRequireDefault(asyncToGenerator.exports);

var _logger = _interopRequireDefault(logger);

var defaultOptions = {
  debug: false,
  delay: 500,
  onError: function onError() {}
};
/**
 * Client side tasks queue
 * @class
 * @example
 * ```ts
 * const queue = new Queue()
 * queue.push(() => {})
 * ```
 */

var Queue = /*#__PURE__*/function () {
  /**
   * @param options Options
   */
  function Queue(options) {
    var _this = this;

    this.running = false;
    this.execute = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var task;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            task = _this.tasks.shift();

            if (task) {
              _context.next = 4;
              break;
            }

            _this.log('Queue is empty. Waiting for a new task');

            return _context.abrupt("return");

          case 4:
            _context.prev = 4;

            _this.log('Task found. Run executor', task);

            _context.next = 8;
            return task();

          case 8:
            _context.next = 14;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);

            _this.log('Run executor failed', _context.t0);

            if (_this.options.onError) {
              _this.options.onError(_context.t0, task);
            }

          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 10]]);
    }));
    this.options = (0, _extends2.default)({}, defaultOptions, options);
    this.tasks = [];
    this.logger = new _logger.default('queue');
    this.log("Starting process tasks after " + this.options.delay + "ms");
    this.run();
  }
  /**
   * Add task in queue
   * @param task Task function
   */


  var _proto = Queue.prototype;

  _proto.push = function push(task) {
    this.pushTask(task);
  };

  _proto.log = function log(message, meta) {
    if (!this.options.debug) return;
    this.logger.debug(message, meta);
  };

  _proto.pushTask = function pushTask(task) {
    this.tasks.push(task);
    this.log('Task registered. Waiting for CPU is idle', task);

    if (this.running) {
      this.requestPopInIdle();
    }
  };

  _proto.requestPopInIdle = function requestPopInIdle() {
    (window.requestIdleCallback || window.setTimeout)(this.execute);
  };

  _proto.run = function run() {
    var _this2 = this;

    if (typeof window !== 'undefined') {
      var performance = window.performance.getEntriesByType('navigation')[0];

      if (performance && performance.loadEventEnd > 0) {
        this.runTasksExecutor();
      } else {
        window.addEventListener('load', function () {
          return setTimeout(_this2.runTasksExecutor.bind(_this2), _this2.options.delay);
        });
      }
    }
  };

  _proto.runTasksExecutor = function runTasksExecutor() {
    var _this3 = this;

    this.tasks.forEach(function () {
      return _this3.requestPopInIdle();
    });
    this.running = true;
  };

  return Queue;
}();

var _default = Queue;
default_1 = queue$1.default = _default;

var modules_bbe8aac2 = {"container":"_114hun7","logoCarousel":"_flr917","tracks":"_w636wm","tracks--item":"_1fsqfok","logotype":"_1mi9mjv"};
import "./assets/LogoCarousel.css";

var LogoCarouselItem = React__default.memo(React__default.forwardRef(function (props, ref) {
    var url = props.url, alt = props.alt, className = props.className, otherProps = __rest(props, ["url", "alt", "className"]);
    var cx = useStyles(modules_bbe8aac2);
    var _a = __read(useBoolean(false), 2), isError = _a[0], setIsError = _a[1];
    if (isError) {
        return null;
    }
    return (React__default.createElement("img", __assign({}, otherProps, { ref: ref, className: cx(modules_bbe8aac2.logotype, className), onError: setIsError.on, src: url, loading: "lazy", decoding: "async", alt: alt !== null && alt !== void 0 ? alt : '' })));
}));

var queue = [];
try {
    queue = new default_1({ debug: false });
}
catch (e) {
    /** */
}
var getClickOffset = function (e) {
    if (e.nativeEvent instanceof TouchEvent) {
        return e.nativeEvent.touches[0].clientX;
    }
    if (e.nativeEvent instanceof MouseEvent) {
        return e.nativeEvent.clientX;
    }
    return 0;
};
/**
 * @description LogoCarousel component. The Logotype slider primarily used for landing pages
 *
 * @component
 * @example
 * ```jsx
 * <LogoCarousel items={items} />
 * ```
 */
var LogoCarousel$1 = React__default.forwardRef(function (props, ref) {
    var className = props.className, items = props.items, classNameItem = props.classNameItem, _a = props.speed, speed = _a === void 0 ? 1 : _a, restProps = __rest(props, ["className", "items", "classNameItem", "speed"]);
    var cx = useStyles(modules_bbe8aac2);
    var tracksRef = useRef({ length: 0, items: [] });
    var containerRef = useRef(null);
    var animationRef = useRef(0);
    var positionRef = useRef(0);
    var dragOffsetRef = useRef(0);
    var startTimeRef = useRef(0);
    var trackWidthRef = useRef(0);
    var tracksCountRef = useRef(1);
    var _b = __read(useState(1), 2), tracksCount = _b[0], setTrackCount = _b[1];
    var isDragging = useRef(false);
    var _c = __read(useState(false), 2), isRenderDragging = _c[0], setIsRenderDragging = _c[1];
    var tracks = Array(tracksCount).fill(null);
    var getTrackWidth = function () {
        var track = tracksRef.current.items[0];
        if (track !== undefined && track !== null) {
            return track.clientWidth;
        }
        return 0;
    };
    var getTracksCount = function () {
        if (containerRef.current === null || trackWidthRef.current === 0) {
            return 1;
        }
        var tracksTotalAmount = 5;
        return Math.ceil(containerRef.current.clientWidth / trackWidthRef.current) + tracksTotalAmount;
    };
    var setPosition = function (offset) {
        var trackWidth = trackWidthRef.current;
        positionRef.current = offset;
        for (var i = 0; i < tracksRef.current.length; i++) {
            var track = tracksRef.current.items[i];
            var trackOffset = offset >= trackWidth * (i + 1) ? trackWidth * (tracksCountRef.current - i) - offset : -offset + trackWidth * i;
            if (track) {
                track.style.transform = "translateX(" + trackOffset + "px)";
            }
        }
    };
    var animate = function (timestamp) {
        var timeToReposition = 16;
        var maxTimeToReposition = 50;
        var minTimeToReposition = 50;
        var speedMultiplier = 40;
        try {
            var timePassed = timestamp - startTimeRef.current;
            if (timePassed >= timeToReposition) {
                if (timePassed > maxTimeToReposition) {
                    timePassed = minTimeToReposition;
                }
                var position = (positionRef.current + (timePassed / speedMultiplier) * speed) % trackWidthRef.current;
                startTimeRef.current = timestamp;
                if (position !== 0 && !Number.isNaN(position)) {
                    setPosition(position);
                }
            }
            animationRef.current = requestAnimationFrame(animate);
        }
        catch (e) {
            console.warn('Animation Error');
        }
    };
    var onActionStart = useCallback(function (e) {
        setIsRenderDragging(true);
        isDragging.current = true;
        dragOffsetRef.current = getClickOffset(e) + positionRef.current;
    }, [isDragging.current, dragOffsetRef.current, positionRef.current]);
    var onMove = useCallback(function (mouseOffset) {
        if (!isDragging.current) {
            return;
        }
        var trackWidth = trackWidthRef.current;
        var position = dragOffsetRef.current - mouseOffset;
        if (position < 0) {
            position += trackWidth;
        }
        else if (position > tracksCountRef.current * trackWidth) {
            position %= tracksCountRef.current * trackWidth;
        }
        setPosition(position);
    }, [isDragging.current, trackWidthRef.current, dragOffsetRef.current, tracksCountRef.current, setPosition]);
    var onMouseMove = useCallback(function (e) { return onMove(e.clientX); }, []);
    var onTouchMove = useCallback(function (e) { return onMove(e.touches[0].clientX); }, []);
    var onActionEnd = useCallback(function () {
        setIsRenderDragging(false);
        isDragging.current = false;
    }, []);
    var trackItemRef = function (e, i) {
        tracksRef.current.length = tracks.length;
        tracksRef.current.items[i] = e;
    };
    useEffect(function () {
        if (isRenderDragging) {
            return;
        }
        queue.push(function () {
            animationRef.current = requestAnimationFrame(animate);
        });
        return function () {
            cancelAnimationFrame(animationRef.current);
        };
    }, [isRenderDragging, animationRef]);
    useEffect(function () {
        var queueUpdateTime = 500;
        var tmp;
        queue.push(function () {
            tmp = setInterval(function () {
                var count = getTracksCount();
                trackWidthRef.current = getTrackWidth();
                if (tracksCountRef.current !== count) {
                    tracksCountRef.current = count;
                    setTrackCount(count);
                }
            }, queueUpdateTime);
        });
        window.addEventListener('mouseup', onActionEnd);
        window.addEventListener('touchend', onActionEnd);
        window.addEventListener('touchcancel', onActionEnd);
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('touchmove', onTouchMove);
        return function () {
            window.removeEventListener('mouseup', onActionEnd);
            window.removeEventListener('touchend', onActionEnd);
            window.removeEventListener('touchcancel', onActionEnd);
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('touchmove', onTouchMove);
            if (tmp) {
                clearInterval(tmp);
            }
        };
    }, [
        tracksCountRef,
        setTrackCount,
        trackWidthRef,
        getTracksCount,
        getTrackWidth,
        onActionEnd,
        onMouseMove,
        onTouchMove,
    ]);
    if (!Array.isArray(items) || items.length === 0) {
        return null;
    }
    return (React__default.createElement("div", __assign({ ref: ref, "data-qa": "LogoCarousel", className: cx(className, modules_bbe8aac2.container) }, restProps),
        React__default.createElement("div", { className: modules_bbe8aac2.logoCarousel, "data-qa": "LogoCarouselInner", onMouseDown: onActionStart, onTouchStart: onActionStart, style: { cursor: isRenderDragging ? 'grabbing' : 'grab' }, ref: containerRef }, tracks.map(function (_, i) { return (React__default.createElement("div", { className: modules_bbe8aac2.tracks, key: "logobox-track-" + i },
            React__default.createElement("div", { className: modules_bbe8aac2['tracks--item'], ref: function (e) { return trackItemRef(e, i); } }, items.map(function (logo) { return (React__default.createElement(LogoCarouselItem, __assign({ className: classNameItem, key: logo.url }, logo))); })))); }))));
});
var LogoCarouselMemo = React__default.memo(LogoCarousel$1);

export { LogoCarouselMemo as LogoCarousel };
